var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"null-page"},[_c('div',[(_vm.type == 1)?_c('img',{attrs:{"src":require("@/assets/coupon_none_list.png"),"alt":""}}):_c('img',{attrs:{"src":require("@/assets/transfer_is_null.png"),"alt":""}}),_c('div',{staticClass:"null-page-title"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }